import { Component, Prop } from 'vue-property-decorator';
import Vue from '@/VueBase';

const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 50;
const ALERT_THRESHOLD = 20;

const COLOR_CODES = {
  info: {
    color: 'green',
  },
  warning: {
    color: 'orange',
    threshold: WARNING_THRESHOLD,
  },
  alert: {
    color: 'red',
    threshold: ALERT_THRESHOLD,
  },
};

@Component
export default class CountdownMixins extends Vue {
  public timePassed: number = 0;
  public timerInterval: number | null = null;

  @Prop()
  public readonly time!: number;

  @Prop()
  public readonly size!: number;

  mounted() {
    this.startTimer();
  }

  beforeDestroy() {
    clearInterval(this.timerInterval || undefined);
  }

  get circleDasharray() {
    return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
  }

  get formattedTimeLeft() {
    const timeLeft = this.timeLeft;
    const minutes = Math.floor(timeLeft / 60);
    let seconds: string | number = timeLeft % 60;

    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    return this.time >= 60 ? `${minutes}:${seconds}` : String(seconds);
  }

  get timeLeft() {
    return this.time - this.timePassed;
  }

  get timeFraction() {
    const rawTimeFraction = this.timeLeft / this.time;
    return Math.max(rawTimeFraction - (1 / this.time) * (1 - rawTimeFraction), 0);
  }

  get remainingPathColor() {
    const { alert, warning, info } = COLOR_CODES;
    let percent = this.timeLeft > 0 ? (100.0 * this.timeLeft) / this.time : 0;

    if (percent <= alert.threshold) {
      return alert.color;
    } else if (percent <= warning.threshold) {
      return warning.color;
    } else {
      return info.color;
    }
  }

  public startTimer() {
    this.timerInterval = setInterval(() => {
      this.timePassed += 1;
      if (this.timePassed >= this.time) {
        clearInterval(this.timerInterval || undefined);
        this.$emit('stop');
      }
    }, 1000);
  }
}
